import type { FaireProductEntity } from "../../entity_types/product";

export const p_pvbe8bkn78: FaireProductEntity = {
  token: "p_pvbe8bkn78",
  type: "product",
  name: "Daily Grooming Brush",
  brandToken: "b_bf7zwxbsts",
  brandName: "Dandylion",
  imageUrl: "https://cdn.faire.com/fastly/c1641a7dc7ff9e0782d16c35cf625d80ac2ee5bc32c128ea8f4f9f69aaeb2ca3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d39d2a8bf2cf171d228619f20deee45b6eb553048df314b68adf503b04a74bc9.jpeg",
    "https://cdn.faire.com/fastly/b3e4ba6b16a9ac292bb32a03fff89cde0aa6e925a85d7574132a357a4d63e7e2.jpeg"
  ],
  priceDollars: 12,
  description: "\"The only brush my dog doesn't hate\" \nWhy we love it: Makes brushing and detangling a gentle, stress-free everyday ritual at home. ",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T16:24:40.112Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
